import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { MIN_SEAT_EXCURSION } from 'shared/constants'
import { Button } from 'shared/ui/button'
import { ButtonInput } from 'shared/ui/button-input'
import { Paper } from 'shared/ui/paper'

import styles from './styles.module.scss'

export const PassengersCount = observer(() => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapperClass}>
      <div className={styles.titleWrapper}>
        <h3>{t('excursions.how_many_peoples')}</h3>
      </div>
      <div className={styles.wrapperCountPassenger}>
        <Paper padding={[8, 16]}>
          <div className={styles.countPassenger}>
            <div className={styles.item}>
              <ButtonInput
                alignCenter
                value={0}
                onChange={() => {}}
                minNumber={MIN_SEAT_EXCURSION}
                title={t('excursions.participants')}
              />
            </div>
          </div>
        </Paper>
      </div>

      <Button onClick={() => {}}>
        <span className={styles.text}>{t('select_without_date')}</span>
      </Button>
    </div>
  )
})
